import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
};

export const expireAlertSlice = createSlice({
  name: "expireAlert",
  initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state, action) => {
      state.visible = false;
    },
  },
});

export const { show: showExpireAlert, hide: hideExpireAlert } =
  expireAlertSlice.actions;

export default expireAlertSlice.reducer;
